module.exports = __webpack_public_path__ + "static/media/circle.9077eb89.png";